import http from "@/plugins/http";
//注意GET 和POST时，参数不同，一个时params 一个时data
export function errorList(data) {
    return http({
        url: `/error/list`,
        params: data,
        method: "GET"
    });
}

export function errorInfo(data) {
    console.log(data);
    return http({
        url: `/error/info`,
        params:data,
        method: 'GET',
    })
}

export function deleteError(data) {
    console.log(data);
    return http({
        url: `/error/delete`,
        params:data,
        method: 'GET',
    })
}

export function errorConfirm(data) {
    console.log(data);
    return http({
        url: `/error/confirm`,
        params:data,
        method: 'GET',
    })
}

export function errorCancel(data) {
    console.log(data);
    return http({
        url: `/error/cancel`,
        params:data,
        method: 'GET',
    })
}
